import React from 'react';
import { Box } from 'reactjs-admin-lte';
import { Table } from 'react-bootstrap';
import DateFormatter from 'components/core/DateFormatter';

const TranslatorJobDetailBasicInfo = (props) => {
  
  const {
    isLoading,
    job,
    assignment,
  } = props;

  return (
    <Box
      className="box-widget"
      loading={isLoading}>
      <Box.Header>
        <Box.Title>Basic Information</Box.Title>
        <Box.Tools>
          <Box.CollapsedToggleButton />
        </Box.Tools>
      </Box.Header>
      <Box.Body noPadding={true}>
        <Table responsive>
          <tbody>
            <tr>
              <th>Number</th><td>{job.number}</td>
              <th>Status</th><td>{job.status}</td>
            </tr>
            <tr>
              <th>Service</th><td>{job.service && job.service.name}</td>
              <th>Source</th><td>{job.sourceCount}</td>
            </tr>
            <tr>
              <th>Deadline</th>
              <td>
                <DateFormatter
                  datetime={assignment && assignment['deadline']}
                  format="YYYY-MM-DD HH:mm"
                  isStrict={assignment && assignment['strictDeadline']} />
              </td>
              <th>Target</th>
              <td>{job.targetCount}</td>
            </tr>
            <tr>
              <th>Subject</th><td colSpan="3">{job.subject}</td>
            </tr>
            <tr>
              <th>Coordinator</th><td colSpan={3}>{job.coordinator && job.coordinator.username}</td>
            </tr>
          </tbody>
        </Table>
      </Box.Body>
    </Box>
  )
}

export default TranslatorJobDetailBasicInfo;